import React, { useState } from 'react';
import { IconX, IconDownload } from '@tabler/icons-react';
import './FinisherMedalModal.css';

// Lightbox for a challenge finisher medal: large view + blob download.
// Mirrors the checkpoint image download UX (fetch -> blob -> anchor click),
// which is more reliable than a plain <a download> for cross-origin assets.
const FinisherMedalModal = ({ medalUrl, title, slug, accent, onClose }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  if (!medalUrl) return null;

  const handleDownload = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      const response = await fetch(medalUrl);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const base = (slug || title || 'mythic')
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      link.download = `${base}-finisher-medal.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading finisher medal:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="medal-modal-overlay" onClick={onClose}>
      <div
        className="medal-modal"
        onClick={(e) => e.stopPropagation()}
        style={accent ? { '--medal-accent': accent } : undefined}
      >
        <button className="medal-modal-close" onClick={onClose} aria-label="Close">
          <IconX size={20} />
        </button>
        <img
          className="medal-modal-image"
          src={medalUrl}
          alt={title ? `${title} finisher medal` : 'Finisher medal'}
          crossOrigin="anonymous"
        />
        <div className="medal-modal-content">
          {title && <h3 className="medal-modal-title">{title}</h3>}
          <div className="medal-modal-label">Finisher Medal</div>
          <button className="medal-modal-download" onClick={handleDownload} disabled={isDownloading}>
            <IconDownload size={16} /> {isDownloading ? 'Downloading...' : 'Download Medal'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinisherMedalModal;
